import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * LuxAccordion — reusable expandable item using the established luxury
 * accordion pattern (gold left-border on open, smooth grid-row transition,
 * gold chevron). Same visual treatment as <FAQSection> and the SupportPage
 * FAQ — extracted into a primitive so /docs/troubleshooting (and any
 * future page that needs the same treatment) can reuse it.
 *
 * Renders a single item. For a list, map over your data and render one
 * <LuxAccordion> per item.
 */
export const LuxAccordion = ({
  question,
  children,
  defaultOpen = false,
  testIdPrefix = "lux-accordion",
  testIdSuffix = "",
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const tid = `${testIdPrefix}${testIdSuffix ? "-" + testIdSuffix : ""}`;
  return (
    <div
      className="rounded-xl transition-colors"
      style={{
        background: open ? "var(--lux-card-hover)" : "var(--lux-card)",
        border: "1px solid var(--lux-border)",
        borderLeft: open ? "3px solid var(--lux-gold)" : "1px solid var(--lux-border)",
      }}
      data-testid={tid}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-5 text-left"
        aria-expanded={open}
        data-testid={`${tid}-toggle`}
      >
        <span className="text-[15px] font-medium text-[var(--lux-text)] pr-4">{question}</span>
        <ChevronDown
          className="w-5 h-5 flex-shrink-0 transition-transform duration-300"
          style={{ color: "var(--lux-gold)", transform: open ? "rotate(180deg)" : "none" }}
        />
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-300 ease-out"
        style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
      >
        <div className="overflow-hidden">
          <div className="px-5 pb-5 text-[14px] leading-[1.7]" style={{ color: "var(--lux-text-2)" }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LuxAccordion;
